import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'sample-details',
    templateUrl: './sample-details.component.html',
    styleUrls: [ './sample-details.component.scss' ]
})
export class SampleDetailsComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
}
